import * as React from 'react';
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { PageTitle } from '../../components/StyledComponents';

/**
 * Personal preferences page (linked from the profile/account menu).
 *
 * Currently exposes the default color mode (System / Light / Dark). The
 * choice is saved automatically by MUI's CssVars system to localStorage
 * (key `mui-mode`), so Athena starts in this mode on every sign-in for
 * this browser.
 */
const Preferences = () => {
  const { mode, setMode } = useColorScheme();

  // useColorScheme can be undefined briefly during initial hydration.
  const value = mode ?? 'system';

  const handleChange = (event) => {
    setMode(event.target.value);
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: { sm: '100%', md: '100%' },
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
      }}
    >
      <Box sx={{ p: 3, flex: 1 }}>
        <PageTitle sx={{ mb: 1 }}>Preferences</PageTitle>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Personal settings for how Athena looks and behaves. Choices are saved
          to this browser and persist across sign-ins.
        </Typography>

        <Paper variant="outlined" sx={{ maxWidth: 640, p: 3, mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Appearance
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <FormControl>
            <FormLabel id="default-mode-label" sx={{ mb: 1 }}>
              Default mode
            </FormLabel>
            <RadioGroup
              aria-labelledby="default-mode-label"
              name="default-mode"
              value={value}
              onChange={handleChange}
            >
              <FormControlLabel
                value="system"
                control={<Radio />}
                label="System (follow your operating system)"
              />
              <FormControlLabel
                value="light"
                control={<Radio />}
                label="Light"
              />
              <FormControlLabel value="dark" control={<Radio />} label="Dark" />
            </RadioGroup>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
              Saved to this browser. Athena will start in this mode each time
              you sign in.
            </Typography>
          </FormControl>
        </Paper>
      </Box>
    </Box>
  );
};

export default Preferences;
